<div class="booking">

    <div class="index-head">
        <span>{{title}}!</span>
    </div>
    <div class="padding-10">
      <span>{{message}}</span>
    </div>
  
    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'reminder-popup-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close tabindex="-1" (click)="close()">Close</button>
        <button [attr.guide]="'reminder-popup-btn-2' + '__' + sanitizeUrl(url)" [disabled]="textAccount !='Ok'" (click)="submit()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='Ok' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon></button>
    </div>
</div>